import React from 'react';

export default function AdPlaceholder({ slot }) {
  return (
    <div
      data-ad-slot={slot}
      style={{
        minHeight: 90,
        background: 'var(--color-surface)',
        border: '1px dashed var(--color-border)',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '12px 0',
      }}
    >
      <span style={{ color: 'var(--color-text-muted)', fontSize: 11, fontFamily: 'var(--font-body)', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
        Advertisement
      </span>
    </div>
  );
}
